import normalizeCta from '@models/CTA'

const normalizedIngegno = ({
  tagline,
  title,
  paragraph,
  ctaPrimary,
  ctaSecondary,
  items = [],
  theme = 'white',
  align = 'center',
}) => {
  const itemsPosition = [
    [31, 5],
    [68, 10],
    [40, 73],
    [69, 60],
  ]
  const normalizedItems = Array.isArray(items)
    ? items.map((item, index) => ({
        ...item,
        title: item.title || '',
        description: item.description || '',
        icon: item.icon || '',
        position: {
          x: itemsPosition[index][0],
          y: itemsPosition[index][1],
        },
      }))
    : []

  const normalizedData = {
    tagline,
    title,
    paragraph,
    ctaPrimary: normalizeCta(ctaPrimary),
    ctaSecondary: normalizeCta(ctaSecondary),
    items: normalizedItems,
    theme,
    align,
  }

  return normalizedData
}

export default normalizedIngegno
